<div id="main">
  <!-- TOOLBAR: Above -->
  @if (layoutConfig.layout.toolbar.position === 'above' && !fullscreenService.isFullScreenActive) {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Above -->

  <div id="container-1" class="container">

    <!-- NAVBAR: Left -->
    @if (layoutConfig.layout.navbar.position === 'left' && !fullscreenService.isFullScreenActive) {
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    }
    <!-- / NAVBAR: Left -->

    <div id="container-2" class="container">

      <!-- TOOLBAR: Below fixed -->
      @if (layoutConfig.layout.toolbar.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      }
      <!-- / TOOLBAR: Below fixed -->

      <div id="container-3" class="container" fusePerfectScrollbar
        [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

        <!-- TOOLBAR: Below static -->
        @if (layoutConfig.layout.toolbar.position === 'below-static' && !fullscreenService.isFullScreenActive) {
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        }
        <!-- / TOOLBAR: Below static -->

        <!-- CONTENT -->
        <content id="maincontent" tabindex="-1"></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below static -->
        @if (layoutConfig.layout.footer.position === 'below-static') {
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        }
        <!-- / FOOTER: Below static -->

      </div>

      <!-- FOOTER: Below fixed -->
      @if (layoutConfig.layout.footer.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      }
      <!-- / FOOTER: Below fixed -->

    </div>

    <!-- NAVBAR: Right -->
    @if (layoutConfig.layout.navbar.position === 'right') {
      <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
    }
    <!-- / NAVBAR: Right -->

  </div>

  <!-- FOOTER: Above -->
  @if (layoutConfig.layout.footer.position === 'above') {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
  <!-- FOOTER: Above -->

</div>

<!-- QUICK PANEL -->
@if (!layoutConfig.layout.quickPanel?.hidden) {
  <fuse-sidebar name="quickPanel" position="right" class="quick-panel">
    @if (!layoutConfig.layout.quickPanel?.hidden) {
      <ng-container *ngComponentOutlet="quickPanelComponent"></ng-container>
    }
  </fuse-sidebar>
}
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  @if (!layoutConfig.layout.toolbar.hidden) {
    <toolbar
    [ngClass]="[layoutConfig.layout.toolbar.position, layoutConfig.layout.toolbar.background]"></toolbar>
  }
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!layoutConfig.layout.footer.hidden) {
    <footer
    [ngClass]="[layoutConfig.layout.footer.position, layoutConfig.layout.footer.background]"></footer>
  }
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  @if (!layoutConfig.layout.navbar.hidden) {
    <fuse-sidebar name="navbar" class="navbar-fuse-sidebar"
      [folded]="layoutConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="layoutConfig.layout.navbar.variant"
      class="left-navbar" [ngClass]="layoutConfig.layout.navbar.background"></navbar>
    </fuse-sidebar>
  }

</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
  @if (!layoutConfig.layout.navbar.hidden) {
    <fuse-sidebar name="navbar" position="right" class="navbar-fuse-sidebar"
      [folded]="layoutConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="layoutConfig.layout.navbar.variant"
      class="right-navbar" [ngClass]="layoutConfig.layout.navbar.background"></navbar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / RIGHT NAVBAR -->
